import { TKV2_ORDER_ATTACHMENT_API } from '@aloft/toolkit-shared';

import { useEffect } from 'react';

import { useCreateCompData } from '../../hooks/api/toolkitComponents.ts';
import { useEdgeTrigger } from '../../hooks/useEdgeTrigger.ts';
import { loadNewComps } from '../../redux/features/actions/loadNewComps.ts';
import { LoadCompPayload } from '../../redux/features/actions/loadProperties.ts';
import { addCompsPosted } from '../../redux/features/orderSlice.ts';
import { useAppDispatch, useAppSelector } from '../../redux/hooks.ts';

export function useCompAddSyncDriver(orderID: string) {
  const dispatch = useAppDispatch();
  const firstSaveBatch = useAppSelector((state) => state.order.compSaveQueue[0]);
  const compsToSave = firstSaveBatch?.comps ?? [];

  const { mutate: compDataCreate } = useCreateCompData({
    onSuccess: (data) => {
      const parsed = TKV2_ORDER_ATTACHMENT_API.COMP_DATA.POST.RESPONSE.parse(data);
      const properties = Object.entries(parsed.comps).map(([compId, comp]) => {
        return { id: compId, ...(comp as object) };
      });
      dispatch(
        loadNewComps({
          comps: properties as LoadCompPayload[],
          compSequence: parsed.sequence,
          rentalCompSequence: parsed.rentalSequence,
        }),
      );
      dispatch(addCompsPosted());
    },
  });

  const mutationTrigger = useEdgeTrigger({
    condition: compsToSave.length > 0,
    delayMs: 0,
    action: () => {
      const batch = firstSaveBatch;
      if (!batch) {
        return;
      }
      compDataCreate({
        pathParams: { orderID },
        body: TKV2_ORDER_ATTACHMENT_API.COMP_DATA.POST.REQUEST.BODY.parse({
          comps: batch.comps,
          sequenceTarget: batch.sequenceTarget,
        }),
      });
    },
  });

  useEffect(() => {
    mutationTrigger.restartTimer();
  }, [compsToSave, firstSaveBatch, mutationTrigger]);
}
